(function() {
  if (!document.querySelector('.shopify-section-404')) return;

  var lang = document.documentElement.lang || 'fr';
  var isFr = lang.startsWith('fr');

  // Masquer le contenu JSON brut
  var section404 = document.querySelector('.shopify-section-404');
  if (section404) section404.style.display = 'none';

  var css = [
    '.hortence-404-wrap{display:flex;flex-direction:column;align-items:center;text-align:center;padding:100px 24px 80px;max-width:560px;margin:0 auto}',
    '.hortence-404__label{font-size:11px;letter-spacing:.14em;text-transform:uppercase;color:#888780;margin:0 0 32px}',
    '.hortence-404__title{font-family:var(--font-heading-family,Georgia,serif);font-size:clamp(28px,5vw,42px);font-weight:400;line-height:1.25;color:var(--color-foreground);margin:0 0 20px}',
    '.hortence-404__text{font-size:15px;line-height:1.7;color:var(--color-foreground);opacity:.6;margin:0 0 40px}',
    '.hortence-404__actions{display:flex;flex-direction:column;align-items:center;gap:12px;margin-bottom:48px}',
    '.hortence-404__btn-primary{display:inline-block;background:var(--color-foreground);color:var(--color-background);font-size:12px;font-weight:500;letter-spacing:.1em;text-transform:uppercase;padding:15px 36px;border-radius:2px;text-decoration:none}',
    '.hortence-404__btn-secondary{font-size:13px;color:var(--color-foreground);opacity:.5;text-decoration:underline;text-underline-offset:3px}',
    '.hortence-404__divider{width:100%;border:none;border-top:1px solid rgba(0,0,0,.1);margin:0 0 24px}',
    '.hortence-404__hint{font-size:12px;color:var(--color-foreground);opacity:.4;margin:0 0 16px}',
    '.hortence-404__links{display:flex;flex-wrap:wrap;gap:8px;justify-content:center}',
    '.hortence-404__link{font-size:12px;color:var(--color-foreground);border:1px solid rgba(0,0,0,.2);padding:7px 16px;border-radius:20px;text-decoration:none}'
  ].join('');

  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  var html = isFr ? [
    '<div class="hortence-404-wrap">',
    '<p class="hortence-404__label">Erreur 404</p>',
    '<h1 class="hortence-404__title">Cette page s\u2019est \u00e9clips\u00e9e.</h1>',
    '<p class="hortence-404__text">La page que vous cherchez n\u2019existe plus ou a \u00e9t\u00e9 d\u00e9plac\u00e9e.<br>Mais nos collections, elles, sont bien l\u00e0.</p>',
    '<div class="hortence-404__actions">',
    '<a href="/collections" class="hortence-404__btn-primary">D\u00e9couvrir les collections</a>',
    '<a href="/" class="hortence-404__btn-secondary">Retour \u00e0 l\u2019accueil</a>',
    '</div>',
    '<hr class="hortence-404__divider">',
    '<p class="hortence-404__hint">Vous cherchez quelque chose en particulier\u00a0?</p>',
    '<div class="hortence-404__links">',
    '<a href="/collections/meilleures-ventes-hortence" class="hortence-404__link">Top des ventes</a>',
    '<a href="/collections/pantalons" class="hortence-404__link">Pantalons &amp; jupes</a>',
    '<a href="/collections/chemises-blouses-soie-coton" class="hortence-404__link">Chemises &amp; blouses</a>',
    '<a href="/pages/contact" class="hortence-404__link">Nous contacter</a>',
    '</div></div>'
  ].join('') : [
    '<div class="hortence-404-wrap">',
    '<p class="hortence-404__label">Error 404</p>',
    '<h1 class="hortence-404__title">This page has vanished.</h1>',
    '<p class="hortence-404__text">The page you are looking for no longer exists or has been moved.<br>But our collections are right here.</p>',
    '<div class="hortence-404__actions">',
    '<a href="/collections" class="hortence-404__btn-primary">Discover our collections</a>',
    '<a href="/" class="hortence-404__btn-secondary">Back to home</a>',
    '</div>',
    '<hr class="hortence-404__divider">',
    '<p class="hortence-404__hint">Looking for something specific?</p>',
    '<div class="hortence-404__links">',
    '<a href="/collections/meilleures-ventes-hortence" class="hortence-404__link">Best sellers</a>',
    '<a href="/collections/pantalons" class="hortence-404__link">Trousers &amp; skirts</a>',
    '<a href="/collections/chemises-blouses-soie-coton" class="hortence-404__link">Shirts &amp; blouses</a>',
    '<a href="/pages/contact" class="hortence-404__link">Contact us</a>',
    '</div></div>'
  ].join('');

  var main = document.getElementById('MainContent');
  if (main) main.insertAdjacentHTML('beforeend', html);
})();